import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

export default function PaymentCardTermsAndConditions() {
  return (
    <div style={{ minHeight: '100vh'}}>
      <main style={{ margin: '0 auto', maxWidth: '896px', padding: '0 24px', paddingTop: '64px', paddingBottom: '64px' }}>
        <div style={{ marginBottom: '32px' }}>
          <Link 
            to="/" 
            style={{ 
              display: 'inline-flex', 
              alignItems: 'center', 
              textDecoration: 'none',
              marginBottom: '24px',
              fontSize: '16px'
            }}
          >
            ← Back to Home
          </Link>
          <Typography variant="h1" style={{ 
            fontSize: '2.25rem', 
            fontWeight: 'bold', 
            letterSpacing: '-0.025em', 
            marginBottom: '16px' 
          }}>
            Terms and Conditions – Payment Processing
          </Typography>
          <Typography variant="body1" style={{ 
            fontSize: '1.125rem',
            marginBottom: '32px',
            color: 'text.secondary'
          }}>
            These Terms and Conditions govern payment processing for hotel accommodations and related services facilitated by Unified Event Solutions LLC ("UES") on behalf of its clients and partner hotels.
          </Typography>
        </div>

        <div style={{ lineHeight: '1.7', fontSize: '16px' }}>
          <section style={{ marginBottom: '32px' }}>
            <Typography variant="h2" style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '16px', color: 'text.secondary' }}>
              1. Payment Processing Overview
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '16px' }}>
              Unified Event Solutions LLC acts as a third-party intermediary to facilitate hotel reservations and associated payments. Payment information provided by the customer will be securely collected and processed in accordance with applicable Payment Card Industry Data Security Standards (PCI-DSS).
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '16px' }}>
              All credit card information is tokenized and securely stored using PCI Booking, a PCI-compliant payment processing provider.
            </Typography>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <Typography variant="h2" style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '16px', color: 'text.secondary' }}>
              2. Authorization of Credit Card Use
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '16px' }}>
              By submitting payment information, the cardholder expressly authorizes the following:
            </Typography>
            
            <div style={{ marginBottom: '20px', paddingLeft: '20px' }}>
              <Typography variant="h3" style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '12px', color: 'text.secondary' }}>
                a. Authorization to Unified Event Solutions LLC
              </Typography>
              <Typography variant="body1" style={{ marginBottom: '12px' }}>
                The cardholder authorizes Unified Event Solutions LLC to charge the provided credit card for applicable fees, including:
              </Typography>
              <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
                <li style={{ marginBottom: '8px' }}>
                  A cancellation fee equal to one (1) room night per room for any reservation cancelled after May 15 (or other published cutoff date specific to the event).
                </li>
                <li style={{ marginBottom: '8px' }}>
                  Any applicable service fees disclosed at the time of booking.
                </li>
              </ul>
            </div>

            <div style={{ marginBottom: '20px', paddingLeft: '20px' }}>
              <Typography variant="h3" style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '12px', color: 'text.secondary' }}>
                b. Authorization to Hotel Property
              </Typography>
              <Typography variant="body1" style={{ marginBottom: '12px' }}>
                The cardholder further authorizes that a tokenized version of their credit card may be securely transmitted via PCI Booking to the hotel where their reservation is held.
              </Typography>
              <Typography variant="body1" style={{ marginBottom: '12px' }}>
                The hotel is authorized to access and process payment using this token for:
              </Typography>
              <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
                <li style={{ marginBottom: '8px' }}>Room charges</li>
                <li style={{ marginBottom: '8px' }}>Taxes and applicable fees</li>
                <li style={{ marginBottom: '8px' }}>Incidentals, where applicable</li>
              </ul>
            </div>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <Typography variant="h2" style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '16px', color: 'text.secondary' }}>
              3. Payment Methods
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '16px' }}>
              Customers may select from the following payment options:
            </Typography>
            
            <div style={{ marginBottom: '20px', paddingLeft: '20px' }}>
              <Typography variant="h3" style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '12px', color: 'text.secondary' }}>
                Credit Card:
              </Typography>
              <Typography variant="body1" style={{ marginBottom: '16px' }}>
                The hotel may charge the card in advance of the stay or at the time of check-in/check-out, in accordance with hotel policy.
              </Typography>
            </div>

            <div style={{ marginBottom: '20px', paddingLeft: '20px' }}>
              <Typography variant="h3" style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '12px', color: 'text.secondary' }}>
                Check Payment:
              </Typography>
              <Typography variant="body1" style={{ marginBottom: '12px' }}>
                Customers may elect to pay via check, subject to the following:
              </Typography>
              <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
                <li style={{ marginBottom: '8px' }}>
                  Payment must be received in advance of arrival (typically no later than two (2) weeks prior to check-in unless otherwise stated).
                </li>
                <li style={{ marginBottom: '8px' }}>
                  Instructions for check payment will be provided upon request or at the time of booking.
                </li>
              </ul>
            </div>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <Typography variant="h2" style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '16px', color: 'text.secondary' }}>
              4. Cancellation and No-Show Policy
            </Typography>
            <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>
                Reservations cancelled after the published cutoff date (e.g., May 15) will incur a cancellation fee of one (1) room night per room.
              </li>
              <li style={{ marginBottom: '8px' }}>
                Failure to check in on the scheduled arrival date ("no-show") may result in charges in accordance with hotel policy, which may include one or more nights' room and tax.
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <Typography variant="h2" style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '16px', color: 'text.secondary' }}>
              5. Data Security and Compliance
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '16px' }}>
              All payment data is handled in compliance with PCI-DSS standards through PCI Booking. Unified Event Solutions LLC does not store raw credit card numbers, and all sensitive payment data is tokenized and secured by the payment provider.
            </Typography>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <Typography variant="h2" style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '16px', color: 'text.secondary' }}>
              6. Responsibility and Liability
            </Typography>
            <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>
                Unified Event Solutions LLC facilitates payment processing but is not the merchant of record for hotel charges, unless otherwise explicitly stated.
              </li>
              <li style={{ marginBottom: '8px' }}>
                The hotel is solely responsible for charging the card for room, tax, and incidentals.
              </li>
              <li style={{ marginBottom: '8px' }}>
                Any disputes regarding hotel charges must be resolved directly with the hotel property.
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <Typography variant="h2" style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '16px', color: 'text.secondary' }}>
              7. Acceptance of Terms
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '16px' }}>
              By submitting payment information and completing a reservation through Unified Event Solutions LLC, the cardholder acknowledges and agrees to these Terms and Conditions.
            </Typography>
          </section>
        </div>
      </main>
    </div>
  );
}